import { DOWNLOAD_PAYMENT_REPORT_REQUEST, DOWNLOAD_PAYMENT_REPORT_SUCCESS, DOWNLOAD_PAYMENT_REPORT_FAILURE, DOWNLOAD_PAYMENT_REPORT_RESET } from "../../actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const downloadPaymentReportData = (state = initialState, action) => {
    switch (action.type) {
        case DOWNLOAD_PAYMENT_REPORT_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case DOWNLOAD_PAYMENT_REPORT_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case DOWNLOAD_PAYMENT_REPORT_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload, data: null });
        case DOWNLOAD_PAYMENT_REPORT_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default downloadPaymentReportData;
